export default {
  default: () => import("/build/src/layouts/default.vue").then(m => m.default || m)
}